















import { Component, Vue } from "vue-property-decorator";
import QuadrantChart, {
  QuadrantChartItem,
  QuadrantChartLabels,
} from "@/components/QuadrantChart.vue";

@Component({ components: { QuadrantChart } })
export default class Charts extends Vue {
  mounted() {}

  get quadrantChartLabels(): QuadrantChartLabels {
    return {
      rightLabel: "Alta copertura",
      leftLabel: "Bassa copertura",
      topLabel: "Bassa dispersione",
      bottomLabel: "Alta dispersione",
    };
  }

  get quadrantChartItems(): QuadrantChartItem[] {
    return [
      {
        label: "Rai 1",
        xPercentage: 0,
        yPercentage: 100,
      },
      {
        label: "Canale 5",
        xPercentage: 100,
        yPercentage: 0,
      },
      {
        label: "Rai 2",
        xPercentage: 50,
        yPercentage: 50,
      },
      {
        label: "La 7",
        xPercentage: 100,
        yPercentage: 0,
      },
      {
        label: "Italia 1",
        xPercentage: 10,
        yPercentage: 30,
      },
      {
        label: "Italia 2",
        xPercentage: 0,
        yPercentage: 0,
      },
      {
        label: "Italia 3",
        xPercentage: 50,
        yPercentage: 0,
      },
      {
        label: "Italia 4",
        xPercentage: 100,
        yPercentage: 50,
      },
      {
        label: "Italia 5",
        xPercentage: 50,
        yPercentage: 100,
      },
    ];
  }
}
